const InterventionPlanTabs = Object.freeze({
  InterventionPlanManagement: 0,
  InterventionPlanSign: 1,
});

export default InterventionPlanTabs;
